module.exports = __webpack_public_path__ + "static/remember_the_milk_3-a376972e07654a40c7d8ac38a2abbb23.png";